import { Component, OnInit, ViewChild, TemplateRef, Input, AfterViewInit } from '@angular/core';
import { IEpGridModel, EpEventService, IEpGridSelectionOptions, EpGridEvent, IEpGridColumn, IEpComponentEventArg, IEpNumericBoxModel } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents, EpbtGridCardControlComponent, PageNames } from 'ep-bt-controls';
import { FieldAgentClient, Product, QuantityFromTallyRequest, QuantityFromTallyResponse, Tally, Per } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFaQuickTransferService } from '../../services/epbt-fa-quick-transfer.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';


declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-transfer-selected-products-grid',
  templateUrl: './epbt-fa-quick-transfer-selected-products-grid.component.html',
  styleUrls: ['./epbt-fa-quick-transfer-selected-products-grid.component.scss']
})
export class EpbtFaQuickTransferSelectedProductsGridComponent implements OnInit {

  products: any;
  public gridModel: IEpGridModel;
  bistrackSettings: any;
  currency: string;
  webTrackUser: any;
  branchId: number;
  @Input() isSummary: boolean;

  @ViewChild('removeTemplate', { static: true }) removeTemplate: TemplateRef<any>;
  @ViewChild('productQuantityTemplate', { static: true }) productQuantityTemplate: TemplateRef<any>;

  @ViewChild(EpbtGridCardControlComponent, { static: false }) gridCardControlComponent: EpbtGridCardControlComponent;

  constructor(private client: FieldAgentClient, private router: Router, private config: BistrackConfig,
    public epEvent: EpEventService, private quciktransferService: EpbtFaQuickTransferService, private productService: EpbtFaProductService,
    private sortService: EpbtFaSortService) { }

  ngOnInit() {
    if (this.quciktransferService.bisTrackSettings) {
      this.gridModel = this.getGridModel();
      this.updateProductsGridData();
    }
  }
  // bindQuickTransferLines() {

  //   let transferLines = this.quciktransferService.quickTransfer.quickTransferLines;
  //   if (transferLines && transferLines.length > 0) {
  //     let productsList: Product[] = [];
  //     let talliesReq: QuantityFromTallyRequest[] = [];

  //     transferLines.forEach(line => {
  //       let tallyreq: QuantityFromTallyRequest = new QuantityFromTallyRequest();
  //       tallyreq.lineNumber = line.lineNumber;
  //       tallyreq.productID = line.product.productId;
  //       tallyreq.quantityTally = line.quantityTally;
  //       tallyreq.quantityPerID = line.product.inputPer.perId;
  //       tallyreq.thickness = line.product.thickness;
  //       tallyreq.width = line.product.width;
  //       tallyreq.precision = 4;
  //       talliesReq.push(tallyreq);
  //       line.product.dateTimeLastModified=new Date();
  //       productsList.push(line.product);
  //     });
  //     console.log(productsList, "productsList");
  //     this.quciktransferService.loadAllProductsPers(productsList, (outProductsList: Product[]) => {
  //       this.quciktransferService.getQuantitiesFromTallies(talliesReq, (talliesRes: QuantityFromTallyResponse[]) => {

  //         transferLines.forEach(line => {
  //           if (line.isTallyLine) {

  //             if (!line.tallyCustom) {
  //               line.tallyCustom = new EpbtFaTallyModel();
  //             }
  //             else {
  //               // Initialize line Input per values
  //               // we do not allow change input per fro tallied products, initialize
  //               // line input per valuesfrom Product
  //               line.product = outProductsList && outProductsList.length > 0 ? outProductsList.find(pro => pro.productId == line.product.productId) : line.product;
  //               line.inputPer = line.product.inputPer;
  //               line.inputPerCode = line.inputPer.perCode;
  //               line.inputPerID = line.inputPer.perId;
  //               // Initialize line Per values
  //               line.per = line.inputPer;
  //               line.perID = line.per.perId;
  //               // calulate Tally qty
  //               let tallyRes = talliesRes && talliesRes.length > 0 ? talliesRes.find(tally => tally.lineNumber == line.lineNumber && tally.productID == line.product.productId) : null;
  //               if (tallyRes != null) { line.quantity = tallyRes.quantity }
  //               else { line.quantity = 0 }
  //             }
  //           }
  //           else {
  //             // so far we allow user change input per in UI for non tallied products
  //             line.perID = line.inputPerID != 0 ? line.inputPerID : line.product.inputPer.perId; // selected input per ID, populated from UC
  //           }

  //         });
  //         this.quciktransferService.quickTransfer.quickTransferLines = transferLines;
  //         this.gridModel.data = transferLines;

  //       });
  //     });

  //   }
  //   else { transferLines = null; }

  // }



  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'product.productId', title: '', width: 30, hidden: true },
        { field: 'product.productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'product.description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'quantity', title: 'QTY', width: 30, hidden: false, cellTemplate: this.productQuantityTemplate },
        { field: 'inputPer.perCode', title: 'UOM', width: 30, hidden: false },
        { field: 'lineNumber', title: 'LINE', width: 30, hidden: false },
        { title: 'DELETE', width: 30, hidden: false, class: 'ep-color-red', cellTemplate: this.removeTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event.column.displayTitle != 'DELETE' && eventArg.event && eventArg.event.type == 'click') {
          this.quciktransferService.isNegotiationEdit = true;
          this.productService.selectedProductItem = eventArg.event.dataItem.product;
          this.quciktransferService.quickTransfer.selectedLineIndex = eventArg.event.dataItem.lineNumber;
          this.productService.fromPage = PageNames.QuickTranferProductSearch;
          this.sortService.previousProductSearchForTransferOrOrder = null;
          this.router.navigate(['/home/product/details/', eventArg.event.dataItem.product.productId]);
        }
      },
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }


  // bindGridColumns(): IEpGridColumn[] {
  //   let gridColumns: IEpGridColumn[];
  //   if (!this.isSummary) {
  //     gridColumns = [
  //       { field: 'product.productId', title: '', width: 30, hidden: true },
  //       { field: 'product.productCode', title: 'CODE', width: 30, hidden: false },
  //       { field: 'product.description', title: 'DESCRIPTION', width: 30, hidden: false },
  //       { field: 'quantity', title: 'Qty', width: 30, hidden: false, cellTemplate: this.productQuantityTemplate },
  //       { field: 'inputPer.perCode', title: 'UOM', width: 30, hidden: false },
  //       { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
  //       { title: 'DELETE', width: 30, hidden: false, class: "ep-color-red", cellTemplate: this.removeTemplate }
  //     ];
  //   }
  //   else {
  //     gridColumns = [
  //       { field: 'product.productId', title: '', width: 30, hidden: true },
  //       { field: 'product.description', title: 'DESCRIPTION', width: 30, hidden: false },
  //       { field: 'product.productCode', title: 'CODE', width: 30, hidden: false },
  //       { field: 'quantity', title: 'Quantity', width: 30, hidden: false, cellTemplate: this.summaryQuantityTemplate },
  //       { field: 'quantityTally', title: 'Tally', width: 30, hidden: false },
  //     ];

  //   }
  //   return gridColumns;
  // }

  // getHeight(): number {
  //   var height = parseInt($('body').height());

  //   if (height > 900) {
  //     //return 300;
  //     return 600;
  //   }
  //   else return 550;//return 500;
  // }
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }
  getHeight(): number {
    const height = $(window).outerHeight() - 350; // 593
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;

  }

  // updateSummaryGridData() {
  //   this.gridSummaryModel = this.getGridModel();
  //   if (this.quciktransferService.quickTransfer.quickTransferLines.length > 0)
  //     this.gridSummaryModel.data = this.quciktransferService.quickTransfer.quickTransferLines.slice();
  //   else
  //     this.gridSummaryModel.data = null;
  // }

  updateProductsGridData() {
    if (this.quciktransferService.quickTransfer.quickTransferLines.length > 0) {
      this.quciktransferService.quickTransfer.quickTransferLines = this.quciktransferService.quickTransfer.quickTransferLines.filter(s => s.isSave);
      this.quciktransferService.quickTransfer.quickTransferLines.forEach(element => {
        if (!element.inputPer) {
          const inputPer = new Per();
          inputPer.perCode = '';
          element.inputPer = inputPer;
        }
      });
      this.gridModel.data = this.quciktransferService.quickTransfer.quickTransferLines.slice();
    } else {
      this.gridModel.data = null;
    }
  }

  onCardClick(line) {
    // if (this.isSummary) {
    this.quciktransferService.isNegotiationEdit = true;
    this.productService.selectedProductItem = line.product;
    this.quciktransferService.quickTransfer.selectedLineIndex = line.lineNumber;
    this.sortService.previousProductSearchForTransferOrOrder = null;
    this.router.navigate(['/home/product/details', line.product.productId]);
    // }
    // else { return }
  }

  onRemove(dataItem: any) {
    const index = this.quciktransferService.quickTransfer.quickTransferLines.findIndex(c => c.lineNumber == dataItem.lineNumber);
    if (index >= 0) {
      let lineNum = 0;
      this.quciktransferService.quickTransfer.quickTransferLines.splice(index, 1);
      this.quciktransferService.quickTransfer.quickTransferLines.forEach(item => item.lineNumber = ++lineNum);
      this.gridModel.data = this.quciktransferService.quickTransfer.quickTransferLines.slice();
      // this.gridSummaryModel.data = this.quciktransferService.quickTransfer.quickTransferLines.slice();
    }
  }

}
